module.exports = __webpack_public_path__ + "static/media/travel-agent.0ad808ad.jpg";